export default {
  SelectorPage: 'SelectorPage',
  SuccessPage: 'SuccessPage',
  OneTimePaymentRequestInputPage: 'OneTimePaymentRequestInputPage',
};
